<template>
  <div class="horizontal-scroll__container" ref="scrollContainer">
    <div class="horizontal-scroll__inner">
      <div class="horizontal-scroll__category" v-for="(category, index) in categoryList" :key="category.value">
        <router-link
          @click.native="centerNavElement(index, $event)"
          :active="isActive"
          :to="`${categoryLinkBasePath}/categories/${category.value}`"
          data-cy="navBarCategory"
        >
          {{ $t(`message.spotlightV2.spotlightCategories.${category.value}`) }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HorizontalScrollBar',
  data() {
    return {
      isActive: false,
    };
  },
  props: {
    categoryList: {
      type: Array,
      required: true,
    },
  },
  computed: {
    categoryLinkBasePath() {
      return this.isSpotlightReport ? '' : this.getProductBasePath();
    },
  },
  methods: {
    centerNavElement(index, event) {
      const targetNav = event.target;
      const { scrollContainer } = this.$refs;

      if (targetNav && scrollContainer) {
        const allNavs = document.getElementsByClassName('horizontal-scroll__category');

        const targetNavElementWidth = targetNav.offsetWidth;
        const targetPaddingOffset = index === 0 || index === allNavs.length - 1 ? 36 : 32; // First and last nav element have more padding
        const navContainerWidth = scrollContainer.offsetWidth;

        let widthSumOfPrecedingNavElements = 0;
        for (let i = 0; i < index; i += 1) {
          // Sum the width of all nav elements preceding the target nav
          widthSumOfPrecedingNavElements += allNavs[i].offsetWidth;
        }

        widthSumOfPrecedingNavElements += (targetNavElementWidth + targetPaddingOffset) / 2; // Add half the width of the target nav

        /*
        If the sum is more than half the container width, subract half the container width.
        This will make it so that the nav element is centered in the scroll container.
        Otherwise, set it to zero.
        */
        if (widthSumOfPrecedingNavElements > navContainerWidth / 2) {
          widthSumOfPrecedingNavElements -= navContainerWidth / 2;
        } else {
          widthSumOfPrecedingNavElements = 0;
        }

        scrollContainer.scroll({
          left: widthSumOfPrecedingNavElements,
          behavior: 'smooth',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';
.horizontal-scroll__container {
  display: flex;
  overflow-x: auto;
  padding: 0;
  font-size: 12px;
  text-transform: capitalize;
  background: $primary;
  white-space: nowrap;

  .horizontal-scroll__inner {
    display: flex;
    max-width: 600px;
    margin: 0 auto;
    width: 100%;
  }

  .horizontal-scroll__category {
    text-align: center;
    padding: 16px;

    &:first-child {
      padding-left: 20px;
    }

    &:last-child {
      padding-right: 20px;
    }

    a {
      color: white;
      text-decoration: none;
    }
  }

  .router-link-active {
    font-weight: bold;
  }

  @media (min-width: $breakpoint-mobile) {
    font-size: 14px;
  }
}
</style>
